import useNotifications from "@/hooks/useNotifications";
import { fmtDate } from "@/lib/api";
import { Bell, CheckCircle, BellRinging } from "@phosphor-icons/react";

/**
 * Standalone /notifications page (linked from Tier 1 bottom nav + every other tier's bell icon).
 */
export default function Notifications() {
  const notifs = useNotifications();

  return (
    <div className="space-y-5 max-w-3xl" data-testid="notifications-page">
      <div className="flex items-end justify-between">
        <div>
          <div className="label-eyebrow">Inbox</div>
          <h1 className="font-display text-[28px] font-bold tracking-tight mt-1">Notifications</h1>
          <div className="text-[12px] text-[var(--span-text-2)] mt-1 font-mono">
            {notifs.unread > 0 ? `${notifs.unread} unread` : "You're all caught up"}
          </div>
        </div>
        <div className="flex items-center gap-2">
          {notifs.permission === "default" && (
            <button
              data-testid="notifs-enable-push"
              onClick={() => notifs.requestPermission()}
              className="span-btn h-9 text-[12px]"
            >
              <BellRinging size={14} /> Enable desktop alerts
            </button>
          )}
          {notifs.unread > 0 && (
            <button
              data-testid="notifs-mark-all-read"
              onClick={notifs.markAllRead}
              className="span-btn span-btn-ghost"
            >
              <CheckCircle size={14} /> Mark all read
            </button>
          )}
        </div>
      </div>

      <div className="card-flat">
        {(!notifs.items || notifs.items.length === 0) ? (
          <div className="px-5 py-12 text-center text-[12px] text-[var(--span-text-2)]">
            No notifications yet.
          </div>
        ) : (
          <ul className="divide-y divide-[var(--span-border)]">
            {notifs.items.map(n => {
              const id = n.notif_id || n.id;
              return (
                <li
                  key={id}
                  data-testid={`notification-${id}`}
                  className={`px-5 py-3 flex items-start gap-3 ${n.read ? "" : "bg-[var(--span-bg-2)]"}`}
                >
                  <Bell size={14} weight={n.read ? "regular" : "fill"} className="mt-1 shrink-0" />
                  <div className="flex-1 min-w-0">
                    <div className={`text-[13px] ${n.read ? "text-[var(--span-text-2)]" : "font-medium"}`}>
                      {n.title || n.body || "Notification"}
                    </div>
                    {n.body && n.title && (
                      <div className="text-[11px] text-[var(--span-text-2)] mt-0.5">{n.body}</div>
                    )}
                    <div className="text-[10px] text-[var(--span-text-2)] font-mono mt-1">{fmtDate(n.created_at)}</div>
                  </div>
                  {!n.read && (
                    <button
                      data-testid={`notif-read-${id}`}
                      onClick={() => notifs.markRead(id)}
                      className="text-[11px] text-[var(--span-text-2)] hover:text-[var(--span-text)]"
                    >
                      Mark read
                    </button>
                  )}
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
}
